const PHONE = 'phone';
const EMAIL = 'email';
const LOCATION = 'location';
const TEXT = 'text';
const MULTIPLE = 'multiple';

export const SAVE_TO_ATTR = 'Save response to attribute';

export const ADS_TYPES = {
  TEXT,
  MULTIPLE,
};

export const TYPES = {
  PHONE,
  EMAIL,
  TEXT,
  MULTIPLE,
};

export const ADS_TYPES_ARRAY = [
  {
    id: 1,
    name: MULTIPLE,
  },
  {
    id: 2,
    name: TEXT,
  },
];

export const TYPES_ARRAY = [
  {
    id: 1,
    name: MULTIPLE,
  },
  {
    id: 2,
    name: TEXT,
  },
  {
    id: 4,
    name: EMAIL,
  },
  {
    id: 5,
    name: PHONE,
  },
];

export const SMS_OPTIN_TYPES_ARRAY = [
  {
    id: 1,
    name: MULTIPLE,
  },
];

export const SMS_REPLY_TYPES_ARRAY = [
  {
    id: 5,
    name: PHONE,
  },
];

export const INSTAGRAM_REPLY_TYPES_ARRAY = TYPES_ARRAY;
